import { render } from "./ShowScore.vue?vue&type=template&id=5949afd3"
import script from "./ShowScore.vue?vue&type=script&lang=js"
export * from "./ShowScore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__